import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BaseLayout from '../../components/BaseLayout.js';
import Card from '../../components/Card.js';
import Title from '../../components/Title.js';
import ShortButton from '../../components/ShortButton.js';
import { CookingPot } from '../../components/CookingSoon.js';
import { Typography } from '@mui/material';
import { verifyAccount } from '../../api/axios.js';

const Verification = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyUserAccount = async () => {
      if (!token) {
        setIsLoading(false);
        setStatusMessage('Verification token is missing. Please check your email link.');
        return;
      }

      try {
        const response = await verifyAccount(token);
        setIsVerified(true);
        setStatusMessage(response.message || 'Your account has been verified successfully. You can now log in.');
      } catch (error) {
        setIsVerified(false);
        setStatusMessage(
          error.response?.data?.error || 
          'Verification failed. The link may be invalid or expired.'
        );
      } finally {
        setIsLoading(false);
      }
    };

    verifyUserAccount();
  }, [token]);

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <>
      <style>
        {`
          .form-container {
            margin: 0 auto;
            padding: 0 24%;
            display: flex;
            flex-direction: column;
            padding-top: 6%;
          }

          .card-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 5px;
            justify-content: center;
          }

          .loading-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 24px;
            text-align: center;
          }

          .status-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 20px;
            padding: 12px;
            text-align: center;
          }

          .status-message {
            width: 100%;
            color: #E1E1E6;
            text-align: center;
            font-family: 'Poppins', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: 140%;
          }

          .status-icon {
            font-size: 48px;
          }

          .success-icon {
            color: #52c41a;
          }

          .error-icon {
            color: #ff4d4f;
          }

          .button-gap {
            padding-bottom: 12px;
          }

        `}
      </style>

      <BaseLayout>
        <div className="form-container">
          <Card>
            <div className="card-content">
              <Title text="Account Verification" />
              
              {isLoading ? (
                <div className="loading-container">
                  <CookingPot />
                  <Typography variant="body2">Verifying your account...</Typography>
                </div>    
              ) : (
                <div className="status-container">
                  <div className="status-icon">
                    {isVerified ? (
                      <span className="success-icon">✓</span>
                    ) : (
                      <span className="error-icon">✗</span>
                    )}
                  </div>
                  
                  <div className="status-message button-gap">
                    {statusMessage}
                  </div>
                  
                  <ShortButton 
                    text="Login" 
                    type="button" 
                    onClick={handleGoToLogin} 
                  />
                </div>
              )}
            </div>
          </Card>
        </div>
      </BaseLayout>
    </>
  );
};

export default Verification;